// namespace Pacem.Animations {
// TODO: Bezier
const pi_half = Math.PI * .5;
const EASINGS = {
    // t: normalized `current time` [0,1]
    linear: t => t,
    sineIn: t => Math.sin(t * pi_half - pi_half) + 1.0,
    sineOut: t => Math.sin(t * pi_half),
    sineInOut: t => .5 * Math.sin(t * Math.PI - pi_half) + .5,
    expoIn: t => (Math.pow(Math.E, t) - 1.0) / (Math.E - 1.0),
    expoOut: t => Math.log(t * (Math.E - 1.0) + 1.0),
    expoInOut: t => t < .5 ? .5 * Easings.expoIn(t * 2) : .5 * (1 + Easings.expoOut(t * 2 - 1.0))
};
function assembleEasing(fn, css) {
    const output = (t) => fn(t);
    output['css'] = css;
    return output;
}
export const Easings = {
    linear: assembleEasing(EASINGS.linear, "linear"),
    sineIn: assembleEasing(EASINGS.sineIn, 'cubic-bezier(0.12, 0, 0.39, 0)'),
    sineOut: assembleEasing(EASINGS.sineOut, 'cubic-bezier(0.61, 1, 0.88, 1)'),
    sineInOut: assembleEasing(EASINGS.sineInOut, 'cubic-bezier(0.37, 0, 0.63, 1)'),
    // TODO: set correct pairing
    expoIn: assembleEasing(EASINGS.expoIn, 'cubic-bezier(0.7, 0, 0.84, 0)'),
    expoOut: assembleEasing(EASINGS.expoOut, 'cubic-bezier(0.16, 1, 0.3, 1)'),
    expoInOut: assembleEasing(EASINGS.expoInOut, 'cubic-bezier(0.87, 0, 0.13, 1)'),
};
//}
